"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _common = require("b2b-components/theme/components/Form/common");
var _Label = require("b2b-components/theme/components/Form/Label");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
var _types = require("../types");
require("./TextInput.scss");
var _excluded = ["className", "id", "inputMode", "type", "value", "autocomplete", "isReadOnly", "isDisabled", "onClearButtonClick", "refCallback", "error", "hasClearButton", "hasFocus", "info", "markingType", "styleType", "text", "onClick"];
var TextInput = function TextInput(_ref) {
  var className = _ref.className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? (0, _key.generateUnique)() : _ref$id,
    _ref$inputMode = _ref.inputMode,
    inputMode = _ref$inputMode === void 0 ? 'text' : _ref$inputMode,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? _types.TEXT_INPUT_TYPE.text : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    autocomplete = _ref.autocomplete,
    isReadOnly = _ref.isReadOnly,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClearButtonClick = _ref.onClearButtonClick,
    refCallback = _ref.refCallback,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$hasClearButton = _ref.hasClearButton,
    hasClearButton = _ref$hasClearButton === void 0 ? false : _ref$hasClearButton,
    _ref$hasFocus = _ref.hasFocus,
    hasFocus = _ref$hasFocus === void 0 ? false : _ref$hasFocus,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _Label.MARKING_TYPE.none : _ref$markingType,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _common.STYLE_TYPE.outlined : _ref$styleType,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)'
    } : _ref$text,
    onClick = _ref.onClick,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var minNumber = type === _types.TEXT_INPUT_TYPE.number ? 0 : undefined;
  var rootClassName = (0, _classnames["default"])('cds-Form-Input', "cds-Form-Input--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), {
    'cds-Form-Input--Error': error,
    'cds-Form-Input--ClearButton': hasClearButton
  }, className);
  var labelClassName = (0, _classnames["default"])('cds-Form-Label', 'cds-TextInput-Label', {
    'cds-TextInput-Label--Top': styleType === _common.STYLE_TYPE.underlinedFloatingLabel && (hasFocus || !!value)
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    markingType: markingType,
    text: text,
    className: labelClassName,
    htmlFor: id
  }, text.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Form-InputContainer"
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, restProps, {
    id: id,
    inputMode: inputMode,
    type: type,
    value: value,
    autoComplete: autocomplete // todo - should be just autoComplete
    ,

    readOnly: isReadOnly // todo - should be just readOnly
    ,

    disabled: isDisabled // todo - should be just disabled
    ,

    ref: refCallback,
    className: "cds-TextInput",
    min: minNumber,
    placeholder: text.placeholder,
    onClick: onClick
  })), hasClearButton && String(value).length > 0 && /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    className: "cds-TextInput-ClearButton",
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    isDisabled: isDisabled // todo - should be just disabled
    ,

    onClick: onClearButtonClick,
    size: _ButtonIcon.BUTTON_ICON_SIZE.small,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost,
    tabIndex: -1
  }))), error && /*#__PURE__*/_react["default"].createElement(_Error.Error, null, error), info && /*#__PURE__*/_react["default"].createElement(_Info.Info, null, info));
};
exports.TextInput = TextInput;